"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenLogoResolvers = void 0;
var Enums_1 = require("./Enums");
var utils_1 = require("./utils");
function normalizedToChecksumAddress(hash) {
    try {
        var checksum = utils_1.toChecksumAddress(hash);
        return checksum;
    }
    catch (err) {
        return hash;
    }
}
exports.TokenLogoResolvers = (_a = {},
    _a[Enums_1.Blockchains.Binance] = function (hash) {
        return "https://icon-service.unifi.report/icon_bsc?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.BinanceTestnet] = function (hash) {
        return "https://icon-service.unifi.report/icon_bsc?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Polygon] = function (hash) {
        return "https://icon-service.unifi.report/icon_matic?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Ethereum] = function (hash) {
        return "https://icon-service.unifi.report/icon_eth?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.EthereumRinkeby] = function (hash) {
        return "https://icon-service.unifi.report/icon_eth?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.EthereumGoerli] = function (hash) {
        return "https://icon-service.unifi.report/icon_eth?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Harmony] = function (hash) {
        return "https://icon-service.unifi.report/icon_one?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Iotex] = function (hash) {
        return "https://icon-service.unifi.report/icon_iotx?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Tron] = function (hash) {
        return "https://icon-service.unifi.report/icon_trc20.php?token=" + hash + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Avalanche] = function (hash) {
        return "https://icon-service.unifi.report/icon_avax?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.BTTC] = function (hash) {
        return "https://icon-service.unifi.report/icon_bttc?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.OntologyTestnet] = function (hash) {
        return "https://icon-service.unifi.report/icon_bttc?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.Ontology] = function (hash) {
        return "https://icon-service.unifi.report/icon_ont?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a[Enums_1.Blockchains.FTM] = function (hash) {
        return "https://icon-service.unifi.report/icon_ftm?token=" + normalizedToChecksumAddress(hash) + "&autoResolve=false";
    },
    _a);
